"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTime = exports.getShortMonth = exports.getShortDayAndDate = exports.getMonthDayYear = exports.getDayMonthYearWithSpace = exports.getDayMonthYear = exports.getDayLongMonthYearWithSpace = exports.getDayAndDate = exports.getDay = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var TIME_FORMAT = 'h:mm A';
var MONTH_ABBREV_FORMAT = 'MMM';
var ZERO_PAD_DAY_FORMAT = 'DD';
var DAY_AND_DATE_FORMAT = 'dddd, D MMM';
var SHORT_DAY_AND_DATE_FORMAT = 'ddd D MMM,';
var DAY_MONTH_YEAR_FORMAT = 'DD/MM/YYYY';
var DAY_MONTH_YEAR_WITH_SPACE = 'DD MMM YYYY';
var DAY_LONG_MONTH_YEAR_WITH_SPACE = 'DD MMMM YYYY';
var MONTH_DAY_YEAR_FORMAT = 'MMMM D, YYYY';
var formatOrNull = (date, formatString) => {
  if (!date) {
    return null;
  }
  var result = (0, _momentTimezone.default)(date).format(formatString);
  if (result === 'Invalid date') {
    return null;
  }
  return result;
};
var getTime = date => formatOrNull(date, TIME_FORMAT);
exports.getTime = getTime;
var getShortMonth = date => formatOrNull(date, MONTH_ABBREV_FORMAT);
exports.getShortMonth = getShortMonth;
var getDay = date => formatOrNull(date, ZERO_PAD_DAY_FORMAT);
exports.getDay = getDay;
var getDayAndDate = date => formatOrNull(date, DAY_AND_DATE_FORMAT);
exports.getDayAndDate = getDayAndDate;
var getShortDayAndDate = date => formatOrNull(date, SHORT_DAY_AND_DATE_FORMAT);
exports.getShortDayAndDate = getShortDayAndDate;
var getDayMonthYear = date => formatOrNull(date, DAY_MONTH_YEAR_FORMAT);
exports.getDayMonthYear = getDayMonthYear;
var getDayMonthYearWithSpace = date => formatOrNull(date, DAY_MONTH_YEAR_WITH_SPACE);
exports.getDayMonthYearWithSpace = getDayMonthYearWithSpace;
var getDayLongMonthYearWithSpace = date => formatOrNull(date, DAY_LONG_MONTH_YEAR_WITH_SPACE);
exports.getDayLongMonthYearWithSpace = getDayLongMonthYearWithSpace;
var getMonthDayYear = date => formatOrNull(date, MONTH_DAY_YEAR_FORMAT);
exports.getMonthDayYear = getMonthDayYear;